export default __webpack_public_path__ + "static/media/nav-logo.fdd8bb88.webp";